const API_BASE_URL = "https://api.shahrizada.ru";
// const API_BASE_URL = "http://192.168.3.10:3001";

export default API_BASE_URL;
